/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-05-25
 * @brief EHP Status 컴포넌트
 *
 ********************************************************************/
import React, { useState } from "react";
// recoli & state
import { useRecoilValue } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
//utils
import clog from "../../../utils/logUtils";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP Status 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function EhcCheckNoItem(props) {
    const curEhcType = props.curEhcType;
    const { company, zone, room, spg } = props.curTreeData;
    //const item = props.curItem;
    const item = null;
    //const userInfo = useRecoilValue(userInfoState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [comment, setComment] = useState("");
    //clog(" ----------------- IN EHC CHECK NO ITEM-----------------------");
    function onClickEhcInfo(e) {
        var divEhcInfo = document.querySelector(".ehc__info");
        var ulEhcInfo = "";
        for (var i = 0; i < divEhcInfo.children.length; i++) {
            var child = divEhcInfo.children[i];
            if (child.tagName == "UL")
                ulEhcInfo = child;
        }
        if (CUTIL.isnull(ulEhcInfo))
            return;
        ulEhcInfo.classList.toggle("on");
    }
    function onClickComment(e) {
        e.preventDefault();
        //var btnComment = (e.target.tagName==="BUTTON")?e.target:e.currentTarget;
        var btnComment = document.querySelector(".btn-comment");
        var divPopupBoxin = document.querySelector(".popup-boxin");
        var btnCommentClose = document.querySelector(".popup-boxin .btn-close");
        clog("btnComment : " + btnComment.tagName + " : CLASS : " + btnComment.className);
        if (!CUTIL.isnull(btnComment))
            btnComment.classList.toggle("on");
        if (!CUTIL.isnull(divPopupBoxin))
            divPopupBoxin.classList.toggle("on");
        if (CUTIL.isnull(btnCommentClose))
            return;
        btnCommentClose.addEventListener("click", function (e) {
            onClickComment(e); // 재귀호출
        });
    }
    function onClickSave(e) {
        alert("commet save and close!!");
        onClickComment(e);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("article", { id: "ehc_checker", 
            //  className="box ehc__score ehc-b">
            className: `box ehc__score ${(curEhcType == "ADVANCED") ? "ehc-a" : (curEhcType == "PREMIUM") ? "ehc-p" : (curEhcType == "BASIC") ? "ehc-b" : "ehc-n"}` },
            React.createElement("div", { className: "box__header" },
                React.createElement("p", { className: "box__title" },
                    React.createElement("span", { className: "cate" }, curEhcType),
                    " e-HC")),
            React.createElement("div", { className: "box__body" }, (!item) &&
                React.createElement("p", { className: "txt-ready" },
                    React.createElement("span", null,
                        React.createElement("strong", null, "e-HC List"),
                        " \uC5D0\uC11C \uC810\uAC80\uD560 \uAE30\uAE30\uB97C \uBA3C\uC800 \uC120\uD0DD\uD574\uC8FC\uC138\uC694."))))));
}
export default EhcCheckNoItem;
